<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100", class: [_vm.skinClasses], attrs: { id: "app" } },
    [
      _c("Loader", { attrs: { show: !!_vm.isLoadingArray.length } }),
      _c(_vm.layout, { tag: "component" }, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true





import themeConfig from '@themeConfig';
import * as vuetoastification_composition from 'vue-toastification/composition';
import * as vue_composition_api from '@vue/composition-api';
import core_app_config_useAppConfig from '@core/app-config/useAppConfig';
import * as vueuse_core from '@vueuse/core';
import store from '@/store';
import layouts_components_Loader_vue from '@/layouts/components/Loader.vue';
import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//

// This will be populated in `beforeCreate` hook








const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () => import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");
 export default ({
  render,
  staticRenderFns,
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    Loader: layouts_components_Loader_vue
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
    ...vuex.mapState("user", ["isLoadingArray"])
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ["primary", "secondary", "success", "info", "warning", "danger", "light", "dark"];

    for (let i = 0, len = colors.length; i < len; i++) {
      themeConfig["$themeColors"][colors[i]] = vueuse_core.useCssVar(`--${colors[i]}`, document.documentElement).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    for (let i = 0, len = breakpoints.length; i < len; i++) {
      themeConfig["$themeBreakpoints"][breakpoints[i]] = Number(vueuse_core.useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2));
    }

    // Set RTL
    const {
      isRTL
    } = themeConfig["$themeConfig"].layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const {
      skin,
      skinClasses
    } = core_app_config_useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    window.addEventListener("resize", () => {
      store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    });
    return {
      skinClasses
    };
  }
});


</script>

